import React from "react";
import { Button, Upload, message } from "antd";
import { Controller, useForm } from "react-hook-form";
import { RiDeleteBin6Line } from "react-icons/ri";

import uploadImg from "../../../src/assets/images/upload_icon.png";

const UploadImages = ({
  setFileList,
  fileList,
  onRemoveImages,
  name = "",
  onChangeImages,
}) => {
  const { control, setError, clearErrors } = useForm();

  return (
    <div className="medicinesListWrapper">
      <div className="text-center medicineUploadFile">
        <div className="fs26fwb">Upload your images</div>
        <div className="fs18fw500 medicineFormats">
          Formats: PNG, JPG | Max file size: 2MB
        </div>
        <div className="uploadFieldScrollWrapper">
          <UploadField
            setFileList={setFileList}
            fileList={fileList}
            onChangeImages={onChangeImages}
            onRemoveImages={onRemoveImages}
            name={name}
          />
        </div>
      </div>
    </div>
  );
};

const MAX_FILES = 5;
const MAX_FILE_SIZE_MB = 2;
const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;

const UploadField = ({ fileList, onChangeImages, onRemoveImages, name }) => {
  const { control, setError, clearErrors } = useForm();

  const beforeUpload = (file) => {
    if (file.size > MAX_FILE_SIZE_BYTES) {
      setError("files", {
        type: "manual",
        message: `File size should be less than ${MAX_FILE_SIZE_MB}MB`,
      });
      message.error(`"${file.name}" exceeds the 2MB limit.`);
      return Upload.LIST_IGNORE; // Ignore the file
    }
    clearErrors("files");
    return true;
  };

  const onChange = ({ fileList: newFileList }) => {
    if (newFileList.length > MAX_FILES) {
      message.error(`You can upload up to ${MAX_FILES} files only.`);
      return;
    }
    onChangeImages(newFileList, name);
  };

  const onRemove = (file) => {
    onRemoveImages(file, name);
  };

  return (
    <div className="uploadImgWrapper">
      <Controller
        name={name}
        control={control}
        render={({ field, fieldState: { error } }) => (
          <>
            <div className="uploaded-images">
              {fileList.map((file, index) => (
                <div key={file.uid} className="orderMedicineCoverImg">
                  <div className="custom-upload-item">
                    {index === 0 && (
                      <div className="cover-label fs14fwb">Cover</div>
                    )}
                    <img src={getsrcValue(file)} alt="uploaded" />
                  </div>
                  <div
                    className="deleteOption position-absolute"
                    onClick={() => onRemove(file)}
                  >
                    <RiDeleteBin6Line color="#fff" size={17} cursor="pointer" />
                  </div>
                </div>
              ))}
            </div>

            <Upload
              {...field}
              listType="picture-card"
              fileList={fileList}
              onChange={onChange}
              beforeUpload={beforeUpload}
              multiple={true}
              showUploadList={false}
              customRequest={null} // Hide Ant Design default UI
            >
              {fileList.length < MAX_FILES && (
                <div className="medicineUploadImgWrapper">
                  <img
                    src={uploadImg}
                    className="medicineUploadImg"
                    alt="Upload"
                  />
                  <div className="fs21fw500 medicineImg">
                    Drag & Drop your images here
                  </div>
                  <div className="">
                    <Button className="medicineBrowseBtn fs18fwb">
                      Click to Browse
                    </Button>
                  </div>
                </div>
              )}
            </Upload>

            {error && <p className="error-message">{error.message}</p>}
          </>
        )}
      />
    </div>
  );
};

const getsrcValue = (file) => {
  if (typeof file?.url === "string" && file?.url?.length)
    return process.env.REACT_APP_API_URL + "medicines/" + file?.url;
  return typeof file === "object"
    ? file.url || URL.createObjectURL(file.originFileObj)
    : " ";
};

export default UploadImages;
